export default "__VITE_ASSET__fc9dee71__"